<app-nav></app-nav>
<div class="header-container">
  <div class="button-container">
    <a href="https://www.maxlifeinsurance.com/term-insurance-plans/get-quote?utmCode=143727634&utm_source=CorporateJourney&utm_medium=GroupBroker&utm_campaign=Secure%20Now%20Broker&utm_content=143727634"
      target="_blank">
      <button class="next-button" (click)="createProspectForTermMaxLife()">Next</button>
    </a>
  </div>
  <div class="header-title">
    <h2>Benifits of <span class="highlight2"> Term </span><span class="highlight3"> Life Insurance</span></h2>
  </div>
</div>
<div class="card-container">
  <div *ngFor="let card of cards; let i = index" class="card" (click)="toggleContent(i)">
    <div class="icon">
      <img [src]="card.icon" alt="Icon">
    </div>
    <div class="title">{{ card.title }}</div>
    <div class="subtitle">{{ card.subtitle }}</div>
    <div class="description">
      {{ card.description }}
      <a *ngIf="!card.showExtra" class="see-how" (click)="toggleContent(i, $event)">see how</a>
      <span *ngIf="card.showExtra" class="extra-content">{{ card.extraContent }}</span>
    </div>
  </div>
</div>